import { useRef, useEffect, useCallback } from 'react';

const NEAR_BOTTOM_THRESHOLD = 100;

/**
 * Auto-scroll hook that scrolls to bottom on new content,
 * but only if the user is already near the bottom.
 */
export function useAutoScroll(deps: unknown[]) {
  const containerRef = useRef<HTMLDivElement>(null);
  const isNearBottomRef = useRef(true);

  const handleScroll = useCallback(() => {
    const el = containerRef.current;
    if (!el) return;

    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    isNearBottomRef.current = distanceFromBottom <= NEAR_BOTTOM_THRESHOLD;
  }, []);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || !isNearBottomRef.current) return;

    el.scrollTop = el.scrollHeight;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { containerRef, handleScroll };
}
